import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWorkshop = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.3034 6.21245C15.3034 6.21245 11.5155 11.5155 5.83366 11.5155M5.83366 11.5155C4.31851 11.5155 1.66699 12.2731 1.66699 15.3034V18.3337H10.0003V15.3034C10.0003 13.4094 12.2731 14.5458 15.3034 9.24275L14.167 8.10639M5.83366 11.5155C6.53688 11.5155 7.21131 11.2361 7.70856 10.7389C8.20582 10.2416 8.48517 9.56719 8.48517 8.86396C8.48517 8.16074 8.20582 7.48631 7.70856 6.98906C7.21131 6.4918 6.53688 6.21245 5.83366 6.21245C5.13043 6.21245 4.45601 6.4918 3.95875 6.98906C3.4615 7.48631 3.18214 8.16074 3.18214 8.86396C3.18214 9.56719 3.4615 10.2416 3.95875 10.7389C4.45601 11.2361 5.13043 11.5155 5.83366 11.5155ZM3.18214 4.6973V2.42457H18.3337V13.0306H16.0609M9.24275 1.66699H12.2731V3.18214H9.24275V1.66699Z",
		stroke: "currentColor",
		strokeWidth: 1.5
	})
});
export default SvgWorkshop;
